<template>
  <div class="doc-instruction">
    <aside class="doc-sidebar">
      <h1>HERON6000 使用手册</h1>
      <nav class="doc-toc">
        <div v-for="(item, index) in menuItems" :key="index" class="menu"
          :class="{ active: currentSection === item.ref }" @click="scrollToSection(item.ref)">
          {{ item.text }}<span v-if="item.important" class="important">&#9733;</span>
        </div>
      </nav>
    </aside>

    <div class="doc-content">

      <section class="doc-section" ref="install">
        <h2>{{ itemIndex('install') }}、安装</h2>
        <p>
          {{ itemIndex('install') }}.1、打开安装包，按提示选择安装时的语言,按提示再选择安装路径， 请重点注意安装目录，用户选择好路径后，软件最终安装路径会补充HERON6000目录，以界面最终显示的为准。点击下一步，等待安装完成。完成后可用快捷方式打开软件。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/install-1.png')" alt="安装界面" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/install-2.png')" alt="安装界面" />
        </div>
        <p>
          {{ itemIndex('install') }}.2、打开软件安装目录，软件目录下HERON6000[127.0.0.1-9009].exe文件，此文件为辅助打开软件，只用于已部署好了工控机后，通过远程访问到工控机时打开软件使用，正常情况下不需要使用此文件。
          使用时将127.0.0.1替换为工控机的IP地址，9009替换为工控机的端口，如HERON6000[192.168.1.100-9011].exe。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/install-3.png')" alt="安装界面" />
        </div>
         <p>
          {{ itemIndex('install') }}.3、卸载软件时，界面会提示是否保留数据，选择保留数据时，软件卸载后再次安装，将安装路径选择在原来路径，由于安装路径会自动补全HERON6000,请自主判断新旧路径保持一致，以界面最终显示的为准，之前的软件数据会被保留；
          选择不保留数据时，软件卸载后再次安装，之前的软件数据会被清空。
         
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/install-4.png')" alt="安装界面" />
        </div>        
      </section>

      <section class="doc-section" ref="login">
        <h2>{{ itemIndex('login') }}、登录</h2>
        <p>
          {{ itemIndex('login') }}.1、登录界面会显示当前软件的版本、文档链接。用户登录使用初始账号密码：admin/123456，登录后请及时修改密码以保障账户安全。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/login.png')" alt="登录界面" />
        </div>
      </section>

      <section class="doc-section" ref="register">
        <h2>{{ itemIndex('register') }}、激活</h2>
        <p>
          {{ itemIndex('register') }}.1、添加设备时需要选择设备类型，相关类型需要在这里填写相应的激活码才能激活，请将序列号或二维码发送给商家获取激活码。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/register-1.png')" alt="激活" />
        </div>
      </section>

      <section class="doc-section" ref="machine">
        <h2>{{ itemIndex('machine') }}、设备</h2>
        <p>
          {{ itemIndex('machine') }}.1、设备新增需要设备类型。<span style="color:red">注意：这里的设备类型需要通过激活才显示，激活功能在顶部菜单栏</span>.
          设备编号,ip不可重复，其他信息按格式填写。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-2.png')" alt="设备" />
        </div>
        <p>
          {{ itemIndex('machine') }}.2、设备操作新增、编辑、删除、等功能。其中恢复会在删除后才展示。右侧有筛选功能，可按区域、状态等筛选设备，其中控制器版本支持范围搜索，如输入3.02-3.05，可查找3.02-3.05的所有版本。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-1.png')" alt="设备" />
        </div>
        <p>
          控制器版本支持范围搜索
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-9.png')" alt="设备" />
        </div>
        <p>
          {{ itemIndex('machine') }}.3、设备导入导出功能。导出是将当前筛选条件下的设备导出为Excel文件，导入是将符合格式的Excel文件导入系统添加设备。导入时也是按区域导入的，如果对应的区域不存在，系统自动创建该区域。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-3.png')" alt="设备" />
        </div>
        <p>
          {{ itemIndex('machine') }}.4、设备升级。该功能只支持HRC-803类型设备，先选择要升级的设备，点击升级后弹出升级对话框，再选择升级包，填写您的帐号密码，点击确认升级即可。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-4.png')" alt="设备" />
        </div>
        <p>
          点击升级后，页面进入升级监控面板，可实时查看升级进度和结果，中途可进行取消操作，但取消操作只能取消等待开始的设备，已开始的设备无法进行取消操作，如有部分设备升级失败，可以结束后进行重试。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-5.png')" alt="设备" />
        </div>
        <p>
          {{ itemIndex('machine') }}.5、参数备份/还原功能。点击参数备份，弹出备份对话框，对话框有两个功能，一下是选择对应的参数进行备份，二是下载已备份好的文件。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-6.png')" alt="设备" />
        </div>
        <p>
          点击参数还原，弹出还原对话框，选择已下载的备份tar文件上传，填写帐号密码，即可对相应的设备还原相关参数。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-7.png')" alt="设备" />
        </div>
        <p>
          参数备份/还原都支持进度总览与详情，也可进行取消与重试操作。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/machine-8.png')" alt="设备" />
        </div>
      </section>

      <section class="doc-section" ref="layout">
        <h2>{{ itemIndex('layout') }}、页面布局</h2>
        <p>
          {{ itemIndex('layout') }}.1、页面顶部是菜单栏，菜单栏左侧是各个功能菜单，右侧有语言切换和用户信息、退出功能。页面左侧有隐藏的侧边栏，右侧是主要内容区。侧边栏可在鼠标移动到左侧边缘时展开，展示后可点击侧边框右上角的 X 关闭。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/page.png')" alt="页面布局" />
        </div>
      </section>

      <section class="doc-section" ref="dashboard">
        <h2>{{ itemIndex('dashboard') }}、控制台</h2>
        <p>
          {{ itemIndex('dashboard') }}.1、以区域维度展示当前已添加的设备。顶部为操作功能区：左侧可展示/折叠设备列表，中间展示在线/离线/重连状态统计，右侧可通过查找框查找设备，并操作全部联机/脱机。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/dashboard-1.png')" alt="控制台-概览" />
        </div>
        <p>
          {{ itemIndex('dashboard') }}.2、设备列表区分区域展示所有设备。每台设备为卡片，显示基本信息与当前状态。点击卡片操作按钮进行相应操作，点击卡片其他区域进入设备监控面板。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/dashboard-2.png')" alt="控制台-设备列表" />
        </div>
      </section>

      <section class="doc-section" ref="sidebar">
        <h2>{{ itemIndex('sidebar') }}、左侧侧边栏</h2>
        <p>
          {{ itemIndex('sidebar') }}.1、鼠标移动到页面左侧边缘时，侧边栏自动展开；同控制台一样，以区域维度展示设备列表。点击侧边栏右上角的 X
          可关闭。点击相应区域可展开/收起设备，点击设备可打开相应设备的监控面板。设备左侧圆圈表示状态：绿色在线，灰色离线，黄色重连中，红色告警。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/sidebar.png')" alt="左侧侧边栏" />
        </div>
      </section>

      <section class="doc-section" ref="region">
        <h2>{{ itemIndex('region') }}、区域</h2>
        <p>
          {{ itemIndex('region') }}.1、区域可操作新增、编辑、删除、等功能。其中恢复会在删除后才展示，区域下已有设备时不可删除区域。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/productline-1.png')" alt="区域" />
        </div>
        <p>
          {{ itemIndex('region') }}.2、区域新增只需填写名称和排序，描述按需填写。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/productline-2.png')" alt="区域" />
        </div>
      </section>

      <section class="doc-section" ref="user">
        <h2>{{ itemIndex('user') }}、用户。</h2>
        <p>
          {{ itemIndex('user') }}.1、用户可操作新增、编辑、删除、恢复功能。其中恢复会在删除后才展示。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/user-1.png')" alt="用户" />
        </div>
        <p>
          {{ itemIndex('user') }}.2、用户新增/编辑需要填写帐号、姓名、密码、确认密码、角色等信息，描述按需填写。其中角色涉及到该用户的权限配置，不同角色有不同的权限，角色在后面的菜单中编辑。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/user-2.png')" alt="用户" />
        </div>
      </section>

      <section class="doc-section" ref="role">
        <h2>{{ itemIndex('role') }}、角色。</h2>
        <p>
          {{ itemIndex('role') }}.1、角色可操作新增、编辑、删除、恢复功能。其中恢复会在删除后才展示。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/role-1.png')" alt="角色" />
        </div>
        <p>
          {{ itemIndex('role') }}.2、点击权限打开角色权限对话框，这里对应展示所有权限列表，一般分为查看和管理，对应各个页面的展示和功能操作，通过勾选相应权限分配给角色，再结合用户所属角色进行权限控制。
          <span style="color:red">注意：修改权限后，需要相应的用户重新登录才生效。</span>
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/role-2.png')" alt="角色" />
        </div>
      </section>

      <section class="doc-section" ref="library">
        <h2>{{ itemIndex('library') }}、参数同步。</h2>
        <p>
          {{ itemIndex('library') }}.1、参数同步分为系统参数同步和规范参数同步。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/library-1.png')" alt="、参数同步" />
        </div>
        <p>
          {{ itemIndex('library') }}.2、系统参数。可选择源设备与目标设备，源设备只能选一个，目标设备可勾选多个，可操作比较和下载。比较结果第一栏为参数名，第二栏显示源设备的参数，后面各列分别显示目标设备的参数。
          同时也可进行下载，将源设备的参数完全同步至目标设备，下载时请注意备份好设备参数，以防不测。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/library-2.png')" alt="、参数同步" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/library-3.png')" alt="、参数同步" />
        </div>
         <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/library-4.png')" alt="、参数同步" />
        </div>       
        <p>
          {{ itemIndex('library') }}.3、规范参数，通过选择两台设备的规范号范围，注意范围数量需保持一致，选择好后可进行比较，有差异的数组会标红显示，也可执行同步，注意规范号会完全覆盖，建议先做好备份。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/library-5.png')" alt="、参数同步" />
        </div>
      </section>

       <section class="doc-section" ref="expulsion">
        <h2>{{ itemIndex('expulsion') }}、飞溅统计。</h2>
        <p>
          {{ itemIndex('expulsion') }}.1、飞溅统计是用于统计焊接时飞溅情况的功能。需要先配置好飞溅统计的相关参数。可配置全局或规范号的。
          全局参数如下：在UIR设置项中，"电阻门限参数全局选用"选项，如选择关闭，则不使用全局配置，优先使用规范号的设置，如选择“开启”,则使用本选项卡中的两个参数
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/expulsion-1.png')" alt="飞溅统计" />
        </div>
        <p>
          {{ itemIndex('expulsion') }}.2、如"电阻门限参数全局选用"选项，关闭状态时，使用规范号的两个参数。<br />
          飞溅判断：以飞溅时间区域门限值为时间间隔，飞溅识别门限为判断下跌比率。如飞溅时间区域门限值设置值为3，飞溅识别门限设置为20，
          则遍历所有焊接时间点，如取1ms时刻电阻值为A，则再取第4ms时刻的电阻值为B，计算下跌比率，(A-B)/A*100计算出跌落比例，如此值大于20%，则判断此时刻点为飞溅点。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/expulsion-2.png')" alt="飞溅统计" />
        </div>
        <p>
          {{ itemIndex('expulsion') }}.2、飞溅统计可选择一定时间范围，区域/设备/焊点/规范/车型/车架vin码/工厂维度计算飞溅合格率。
          其中选择设备后，可再选择规范号，选择焊点后，可过滤焊点范围，选择规范后，可过滤规范号，选择车型后，可再勾选车型，选择车架vin码后，可再填写vin码范围
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/expulsion-3.png')" alt="飞溅统计" />
        </div>
      </section>

      <section class="doc-section" ref="fix">
        <h2>{{ itemIndex('fix') }}、修磨监控。</h2>
        <p>
          {{ itemIndex('fix') }}.1、修磨监控依赖于修磨配置。如下图，每台设备都有自己的修磨配置，需要根据焊接数据配置修磨参考曲线。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/fix-1.png')" alt="修磨监控" />
        </div>
        <p>
          {{ itemIndex('fix') }}.1、填写修磨前后的规范号，点击查询即可查到最近三天的修磨电阻曲线，请注意修磨前后必须是连续的焊接记录才能被查询到。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/fix-2.png')" alt="修磨监控" />
        </div>
        <p>
          {{ itemIndex('fix') }}.2、勾选好列表下的电阻曲线，右侧可预览到选择的曲线，"自动剔除上下公差"选项可根据需要勾选。
          勾选后，系统会计算选中的修磨后电阻曲线平均值，如某一条电阻曲线在平均曲线的上下公差范围之外，则自动剔除该条电阻曲线。点击生成参考曲线，则生成一条选中曲线平均值的参考曲线。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/fix-3.png')" alt="修磨监控" />
        </div>
         <p>
          {{ itemIndex('fix') }}.4、配置告警参数，一是“开启前置过滤”，开启，如曲线修磨前-修磨后平均电阻大于填写值，则认为该条曲线正常，不做公差范围判断。
          <br />二是“修磨后曲线上公差”，配置相应值后，结合参考曲线，判断修磨后曲线是否在公差范围内，点击保存参考曲线，则修订监控监控才生效。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/fix-4.png')" alt="修磨监控" />
        </div>

         <p>
          {{ itemIndex('fix') }}.5、修磨告警，目前只有两种告警，一是修磨后电阻值大于修磨前电阻值。可点击查看，右侧会展示相应的修磨前后曲线，
          参考曲线，以及用虚线表示的上下公差范围
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/fix-5.png')" alt="修磨监控" />
        </div>
         <p>
          第二种“实时修磨后曲线超出公差范围内”，点击可查看，虚线范围为参考曲线的上下公差范围，对比实时曲线-修磨后，
          如超出公差范围，则会出现大红点，提示修磨后曲线超出公差范围。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/fix-6.png')" alt="修磨监控" />
        </div>
      
      </section>

      <section class="doc-section" ref="history">
        <h2>{{ itemIndex('history') }}、系统记录。</h2>
        <p>
          {{ itemIndex('history') }}.1、记录了平台的相关操作和事件，可根据时间与类型进行查找，其中如设备升级，设备参数还原记录也在这里。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/history-1.png')" alt="系统记录" />
        </div>
      </section>

      <section class="doc-section" ref="init">
        <h2>{{ itemIndex('init') }}、系统初始化。</h2>
        <p>
          {{ itemIndex('init') }}.1、选择相应的初始化项，清空相应的数据表。清理时间可选择1周/1个月/3个月/6个月/1年，如选择1周，则数据在1周以前的数据会清理掉。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/init-1.png')" alt="系统初始化" />
        </div>
      </section>

      <section class="doc-section" ref="running">
        <h2>{{ itemIndex('running') }}、实时监控。</h2>
        <p>
          {{ itemIndex('running') }}.1、点击设备卡片空白地方，可进入实时监控面板。面板右侧顶端有面包屑导航，展示设备在线状态，操作联机/脱机。打开告警记录。 <br />
          设备状态可查看设备当前的工作模式，并点击切换。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/running-1.png')" alt="实时监控" />
        </div>
        <p>
          {{ itemIndex('running') }}.2、切换卡片至IO状态，可查看输入输出状态。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/running-2.png')" alt="输入输出状态" />
        </div>
        <p>
          {{ itemIndex('running') }}.3、切换卡片至焊接波形，如焊机正常工作，可查看焊接波形，曲线分为四种，可在波形下方切换要收集的曲线。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/running-3.png')" alt="焊接波形" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/running-4.png')" alt="焊接波形" />
        </div>
        <p>
          {{ itemIndex('running') }}.4、切换卡片至控制器信息，可查看控制器的详细状态和参数。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/running-5.png')" alt="控制器信息" />
        </div>
         <p>
          {{ itemIndex('running') }}.5、切换卡片至趋势观察，可查看实时/历史的焊接记录，以时间点显示所有焊接记录。
          <br />左侧可选择观察对应的规范号或焊点映射号。
          <br />点击趋势图上的一个点，即可查看该点的详细信息，在左下方显示。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/running-6.png')" alt="控制器信息" />
        </div>
      </section>

      <section class="doc-section" ref="program">
        <h2>{{ itemIndex('program') }}、规范参数</h2>
        <p>
          {{ itemIndex('program') }}.1、规范参数分为设备端/离线端，两端参数一致，设备端下载即可同步到设备，离线端保存只能保存到本地，两端可以互相同步，也各自实现导入导出功能。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/program-1.png')" alt="规范参数" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/program-2.png')" alt="规范参数" />
        </div>
      </section>

      <section class="doc-section" ref="production">
        <h2>{{ itemIndex('production') }}、生产管理。</h2>
        <p>
          {{ itemIndex('production') }}.1、生产管理用于配置生产管理的部分参数，还包含电极计数器，电极修磨等功能。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/production-1.png')" alt="生产管理" />
        </div>
        <p>
          {{ itemIndex('production') }}.2、电级计数器配置相同，对应的计数值可以清零，设置清零后，需要点击下载才生效
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/production-2.png')" alt="生产管理" />
        </div>
        <p>
          {{ itemIndex('production') }}.3、电极修磨，功能也相同，其中的步增值设置，需要先打开步增功能，并且设置步增级数大于0，才能进行修磨操作。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/production-3.png')" alt="生产管理" />
        </div>
      </section>

      <section class="doc-section" ref="system">
        <h2>{{ itemIndex('system') }}、系统参数。</h2>
        <p>
          {{ itemIndex('system') }}.1、系统基本参数，可按需修改，记得点击下载，修改才同步到设备。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-1.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.2、焊钳配置。需要在系统参数中选择为机器人点钳或悬挂焊时才会出现。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-2.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.3、电极校准，5个电极校准操作一致，可选择电极压力/初级电流/次级电流。电流校验可选择默认或自校准。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-3.png')" alt="系统参数" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-4.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.4、UIR设置。UIR参数设置按需填写，填写完成后点击下载同步到设备。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-5.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.5、UIR曲线，收集一段时间的曲线，记得按开始记录UIR，收集完成后点击停止记录，并可生成参考同线，
          生成后再下载到控制器，参考曲线即生成完成。要想观察参考曲线，需在实时监控的焊接波形观察，同时重点注意，要能观察到参考曲线，需要将系统参数中的UIR调整开启
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-6.png')" alt="系统参数" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-12.png')" alt="系统参数" />
        </div>
         <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-11.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.6、UIP设置.
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-7.png')" alt="系统参数" />
        </div>
        
        <p>
          {{ itemIndex('system') }}.7、UIP矩形图，可切换规范号。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-8.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.8、软件升级，可实现当前设备的升级。恢复出厂设置，目前只做了规范参数的清空。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-9.png')" alt="系统参数" />
        </div>
        <p>
          {{ itemIndex('system') }}.9、系统备份，目前只做了系统参数的备份。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/system-10.png')" alt="系统参数" />
        </div>
      </section>

      <section class="doc-section" ref="record">
        <h2>{{ itemIndex('record') }}、焊接记录。</h2>
        <p>
          {{ itemIndex('record') }}.1、根据时间和其它参数，查询焊接记录，焊接记录右侧可打开详情，如焊接过程有告警，也会有告警打开的入口。打开焊接详情，可切换卡片查看焊接数据或波形，也可切换图标，切换至下一条或上一条焊接记录
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/record-1.png')" alt="焊接记录" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/record-2.png')" alt="焊接记录" />
        </div>
      </section>

      <section class="doc-section" ref="alarm">
        <h2>{{ itemIndex('alarm') }}、报警记录。</h2>
        <p>
          {{ itemIndex('alarm') }}.1、查找一定时间范围的报警记录，如果该报警是在焊接记录中产生，可点击查看跳转至焊接记录页查看。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/alarm-1.png')" alt="报警记录" />
        </div>
      </section>

      <section class="doc-section" ref="modification">
        <h2>{{ itemIndex('modification') }}、修改记录。</h2>
        <p>
          {{ itemIndex('modification') }}.1、用户修改系统参数或规范参数时产生的记录，卡片焊点管理记录是用户在焊点管理调整时产生的记录。
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/modification-1.png')" alt="修改记录" />
        </div>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/modification-2.png')" alt="修改记录" />
        </div>
      </section>

      <section class="doc-section" ref="prodspot">
        <h2>{{ itemIndex('prodspot') }}、焊点管理。</h2>
        <p>
          {{ itemIndex('prodspot') }}.1、可进行相关操作。
          <br />刷新：将离线数据库数据完全清空，重新从设备中拉取焊点数据
          <br />导入：将符合格式的Excel文件导入系统，合并离线数据库，并将合并后的数据下发到设备
          <br />校验：检查焊点检验位是否正确
          <br />导出：将离线数据库数据导出为Excel文件
          <br />清除：清空离线数据库数据和设备数据
          <br />新建焊点：手动新增焊点数据，每条焊接记录的操作可以再对焊点数据编辑。编辑后请记得做下载操作才能同步到设备
          <br />下载：将当前离线数据库的数据下载至设备
        </p>
        <div class="doc-image-wrap">
          <img :src="require('@/assets/img/instruction/prodspot-1.png')" alt="焊点管理" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocInstruction',
  components: {},
  props: {},
  data() {
    return {
      currentSection: 'install',
      menuItems: [
        { ref: 'install', text: '1、安装' },
        { ref: 'login', text: '2、登录' },        
        { ref: 'register', text: '3、激活', important: true },
        { ref: 'machine', text: '4、设备', important: true },
        { ref: 'layout', text: '5、页面布局' },
        { ref: 'dashboard', text: '6、控制台' },
        { ref: 'sidebar', text: '7、左侧侧边栏' },
        { ref: 'region', text: '8、区域' },
        { ref: 'user', text: '9、用户' },
        { ref: 'role', text: '10、角色' },
        { ref: 'library', text: '11、参数同步' },
        { ref: 'expulsion', text: '12、飞溅统计' },
        { ref: 'fix', text: '13、修磨监控' },
        { ref: 'history', text: '14、系统记录' },
        { ref: 'init', text: '15、系统初始化' },
        { ref: 'running', text: '16、实时监控' },
        { ref: 'program', text: '17、规范参数' },
        { ref: 'production', text: '18、生产管理' },
        { ref: 'system', text: '19、系统参数' },
        { ref: 'record', text: '20、焊接记录' },
        { ref: 'alarm', text: '21、报警记录' },
        { ref: 'modification', text: '22、修改记录' },
        { ref: 'prodspot', text: '23、焊点管理' }
       
      ]
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollToSection(refName) {
      this.currentSection = refName;
      const element = this.$refs[refName];
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // 关键API
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      // 遍历所有ref，找到当前应该高亮的section
      for (let refName in this.$refs) {
        const element = this.$refs[refName];
        if (element && element.offsetTop <= scrollPosition + 100) {
          this.currentSection = refName;
        }
      }
    },
    itemIndex(refName) {
      let rs = 0;
      this.menuItems.forEach((item, index) => {
        if (item.ref === refName) {
          rs= index;
        }
      });
      return rs+1;
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
.doc-instruction {
  min-height: 60vh;
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 24px;
  align-items: start;
  padding: 24px;
  background: #f8fafc;
  scroll-behavior: smooth;
  /* smooth anchor scroll */
}

.doc-sidebar {
  position: sticky;
  top: 16px;
  align-self: start;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.doc-sidebar h1 {
  margin: 0 0 12px;
  font-size: 18px;
  color: #0f172a;
}

.doc-toc {
  display: grid;
  gap: 8px;
}

.doc-toc a {
  display: block;
  color: #334155;
  font-size: 14px;
  text-decoration: none;
  padding: 8px 10px;
  border-radius: 8px;
  transition: color .15s ease, background .15s ease;
}

.doc-toc a:hover {
  color: #2563eb;
  background: #f1f5f9;
}

.doc-content {
  width: 100%;
  max-width: 1024px;
  text-align: left;
  color: #0f172a;
}

.doc-section+.doc-section {
  margin-top: 24px;
}

h2 {
  margin: 0 0 12px;
  font-size: 22px;
  line-height: 1.4;
  font-weight: 700;
  color: #0f172a;
}

p {
  margin: 12px 0 0;
  font-size: 16px;
  line-height: 1.7;
  color: #334155;
}

.doc-image-wrap {
  display: flex;
  justify-content: center;
  /* image centered on its own line */
  align-items: center;
  margin: 8px 0;
}

.doc-image-wrap img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 55vh;
  /* avoid exceeding one screen */
  object-fit: contain;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.menu {
  /* 原有样式 */
  padding: 0px 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.menu.active {
  background-color: #1890ff;
  /* 激活背景色 */
  color: white;
  /* 激活文字颜色 */
  font-weight: bold;
  border-radius: 4px;
}

/* 或者使用更明显的效果 */
.menu.active {
  background-color: rgba(24, 144, 255, 0.1);
  color: #1890ff;
  border-left: 3px solid #1890ff;
  padding-left: 9px;
  /* 3px边框补偿 */
}

/* 鼠标悬停效果 */
.menu:hover:not(.active) {
  background-color: #f5f5f5;
  color: #333;
}

.important {
  color: red;
}
</style>